export function joinOxford(
  parts: readonly string[],
  separator = ', ',
  lastSeparator = ' e '
): string {
  if (!parts.length) return ''
  return parts.reduce(
    (acc, val, i, arr) => acc + (i < arr.length - 1 ? separator : lastSeparator) + val
  )
}
